export const sumYearToDate = (date: Date, years): Date => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const newDate = new Date(year + years, month, day);
  return newDate;
};
